export default __webpack_public_path__ + "static/media/Data_Driven_Showcases.20f8f103.png";